import { Routes, Route } from 'react-router-dom';
import { NavigateToV1 } from '../../app/Routes/AuthenticatedRoutes/AuthenticatedRoutes';
import { EditSheet, SheetWrapper } from './components/EditSheet';
import { CreateSheet } from './components/CreateSheet';
import { useProfile } from '../../hooks';
import {
  Arbeitszeit,
  Dienstgang,
  Rechtshinweise,
  Zuschlaege,
} from './components/EditSheet/content';
import { HistorieWrapper } from './components/EditSheet/content/Historie';
import { AntragSheetWrapper } from './components/AntragSheet/AntragSheet';
import { AntragWrapper } from './components/EditSheet/content/Antrag/AntragWrapper';
import { UebersichtWrapper } from '@/domain/arbeitszeiten/pages/uebersicht/UbersichtWrapper';

export function Arbeitszeiten() {
  const profile = useProfile();

  const rechte = profile.manager.rechte;

  if (rechte.arbeitszeit.erlaubt === false) {
    return <NavigateToV1 />;
  }

  return (
    <Routes>
      <Route
        path="/uebersicht/:year/:month/:day"
        element={<UebersichtWrapper />}>
        <Route
          path="/uebersicht/:year/:month/:day/sheet"
          element={<SheetWrapper />}>
          <Route path="edit/:arbeitszeitId" element={<EditSheet />}>
            <Route index element={<Arbeitszeit />} />
            <Route path="arbeitszeit" element={<Arbeitszeit />} />
            <Route path="hinweise" element={<Rechtshinweise />} />
            <Route path="antraege" element={<AntragWrapper />} />
            <Route path="dienstgaenge" element={<Dienstgang />} />
            <Route path="zuschlaege" element={<Zuschlaege />} />
            <Route path="historie" element={<HistorieWrapper />} />
          </Route>
          <Route path="create" element={<CreateSheet />} />
          <Route path="antrag/:antragId" element={<AntragSheetWrapper />} />
        </Route>
      </Route>
      <Route path="*" element={<NavigateToV1 />} />
    </Routes>
  );
}
